import { GET_DASHBOARD_TODAY } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_DASHBOARD_TODAY:
            return action.payload;
        default:
            return state;
    }
}
